import { patchScheduleItem } from "../api/scheduleItems";
import { patchSchoolEmailEventOverride } from "../api/schoolEmails";
import { isPendingInFlight, listPendingMutations } from "./pendingMutations";

/**
 * Send edits that were still queued when Albis closed.
 * Uses the current session. Does not retry another account's queue.
 * @param {string} userId
 */
export async function flushPendingMutations(userId) {
  if (!userId) return;
  const entries = listPendingMutations(userId);
  for (const entry of entries) {
    if (isPendingInFlight(entry.id)) continue;
    try {
      if (entry.kind === "school-event") {
        // eslint-disable-next-line no-await-in-loop
        await patchSchoolEmailEventOverride(entry.targetId, entry.eventIndex, entry.body, {
          fromQueue: true,
          pendingId: entry.id,
        });
      } else {
        // eslint-disable-next-line no-await-in-loop
        await patchScheduleItem(entry.targetId, entry.body, {
          fromQueue: true,
          pendingId: entry.id,
        });
      }
    } catch {
      /* A dropped connection stays queued. A rejected edit is already dropped. */
    }
  }
}
